import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { getApiUrl } from '@/helpers/api';

export const getPresignedUrl = async (
  userId,
  baseName,
  fileType,
  fileExtension,
  type = 'document'
) => {
  const fileName = `user/${userId}/${baseName}-${uuidv4()}.${fileExtension}`;

  const response = await axios.post(
    `${getApiUrl()}/file/generate-presigned-url?type=${type}`,
    {
      fileName,
      fileType
    }
  );
  const presignedUrl = response.data.url;

  return presignedUrl;
};
